var pagePath = window.location.pathname;
var pageGroup;


function getPageGroup(path) {
    if (path === '/') {
        return 'Homepage';
    } else if (path.includes('/support')) {
        return 'Support page';
    } else if (path.includes('/collections/')) {
        return 'Product list page';
    } else if (path.includes('/products/')) {
        return 'Product detail page';
    } else if (path.includes('/checkouts/')) {
        return 'Chectout page';
    } else if (path.includes('/affiliate')) {
        return 'Affiliate page';
    } else if (path.includes('/blog')) {
        return 'Blog page';
    } else if (path.includes('/reviews')) {
        return 'Review page';
    } else if (path.includes('/after-sales-centre') || path.includes('/pages/narwal-after-service')) {
        return 'After-sales-centre page';
    } else if (path.includes('/product-help')) {
        return 'Product help page';
    } else if (path.includes('/tutorial-videos')) {
        return 'Tutorial videos page';
    } else if (path.includes('/faq')) {
        return 'FAQ page';
    } else if (path.includes('/user-manual')) {
        return 'User manual page';
    } else if (path.includes('/idme')) {
        return 'ID ME Page';
    } else if (path === '/pages/narwal-s10-pro-vacuum-mop' || path === '/pages/freo-xultra-robot-vacuum-and-mop' || path === '/pages/narwal-freo-x-plus-robot-vacuum-and-mop' || path === '/pages/narwal-freo') {
        return 'Product introduction page';
    } else if (path.includes('/pages/fathers-day-sale')) {
        return 'fathers-day-sale page';
    } else if (path.includes('/search')) {
        return 'Search results page';
    } else if (path.includes('-sale')) {
        return 'Campaign page';
    } else if (path.includes('-solution')) {
        return 'Scenario page';
    } else if (path.includes('/account/login')) {
        return 'Login page';
    } else if (path.includes('/account/register')) {
        return 'Register page';
    } else if (path.includes('/referral')) {
        return 'Referral page';
    } else {
        return 'Other page';
    }
}


function catchErrorEvent(en, fn) {
    if (pagePath.indexOf('web-pixel') === -1) {
        try {
            fn && fn();
        } catch (error) {
          console.log('current---', error)
            window.dataLayer.push({
                'event': 'error',
                'error_info': en + ':' + error
            });
        }
    }
}

// ------通用事件------
$narwal.on('DOMContentLoaded', function() {

    catchErrorEvent('click_notification', function() {

        document.querySelectorAll('.swiper-wrapper .swiper-slide.tc .text.mr-5.p3.c-white').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/[^a-zA-Z0-9\s]/g, '');
                var notificationTitle = item.closest('.swiper-slide.tc').querySelector('p').innerText.replace(/[^a-zA-Z0-9\s]/g, '');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_notification',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'top notification',
                        'button_name': buttonName,
                        'notification_title': notificationTitle
                    }
                });
            });
        });

    });

    // 顶部导航
    // 一级
    catchErrorEvent('click_nav', function() {
        document.querySelectorAll('.header-link.flex.jc-center.ai-center.p2.c-black').forEach(function(item) {
            item.addEventListener('mouseover', function() {
                var navigationName1 = item.innerText.replace(/[^a-zA-Z0-9\s]/g, '');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_nav',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'top first navigation',
                        'first_nav': navigationName1
                    }
                });
            });
        });


        // 二级
        document.querySelectorAll('.p2.show-m-inline-block.submenu-link').forEach(function(item) {
            let isHovered = false; // 添加标志位

            item.addEventListener('mouseover', function() {
                if (!isHovered) {
                    isHovered = true; // 设置标志位为 true

                    var navigationName2 = item.innerText;
                    var navigation = item.closest('.desktop-menu-dropdown.absolute')
                        .previousElementSibling.previousElementSibling
                        .querySelector('.active').innerText.replace(/[^a-zA-Z0-9\s]/g, '');

                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_nav',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'top second navigation',
                            'first_nav': navigation,
                            'second_nav': navigationName2
                        }
                    });
                }
            });

            item.addEventListener('mouseout', function() {
                isHovered = false; // 重置标志位为 false
            });
        });


        //三级
        document.querySelectorAll('.product-each-simple').forEach(function(item) {
            item.addEventListener('click', function() {
                var navigationName3 = item.querySelector('.p3.c-black.mt-0,.p3.c-black.mt-10.d-mt-15').innerText.replace(/\n/g, ' ');
                var navigationName2 = item.closest('.container').querySelector('.submenu-link.active').innerText.replace(/\n/g, ' ');
                var navigation = item.closest('.desktop-menu-dropdown.absolute').previousElementSibling.previousElementSibling.querySelector('.active').innerText.replace(/[^a-zA-Z0-9\s]/g, '');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_nav',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'top third navigation',
                        'first_nav': navigation,
                        'second_nav': navigationName2,
                        'third_nav': navigationName3
                    }
                });
            });
        });
    });


    //logo
    catchErrorEvent('logo', function() {
        var headerLogo = document.querySelector('.header-logo');
        if (!headerLogo) return;

        headerLogo.addEventListener('click', function() {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'click_function',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'top function',
                    'button_name': 'logo'
                }
            });
        });

    });
    catchErrorEvent('support', function() {
        //support、购物车、搜索等
        var supportButton = document.querySelector('.header-link.right-side-menu');
        if (!supportButton) return;

        supportButton.addEventListener('click', function() {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'click_function',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'top function',
                    'button_name': 'support'
                }
            });
        });

    });
    catchErrorEvent('header_search_analytics', function() {
        var initializedKey = '__narwalHeaderSearchAnalyticsInitialized';
        if (document[initializedKey]) return;

        document[initializedKey] = true;

        var searchTriggerSelector = '.ndev-site-header__search-trigger, .icon.jc-center.ai-center.sicon.anim-transform.flex';
        var searchFormSelector = '.ndev-site-header__search-form';
        var searchInputSelector = '.ndev-site-header__search-input, .w-full.pt-20.pb-20.p2';
        var legacySearchSubmitSelector = '.absolute.smsi-search-btn';
        var suggestionSelector = '.ndev-site-header__suggestion-link, .product-each-search';
        var suggestionTitleSelector = '.ndev-site-header__suggestion-title, .p2';
        var quickLinkSelector = '.ndev-site-header__quick-link';

        document.addEventListener('click', function(event) {
            var eventTarget = event.target;
            if (!(eventTarget instanceof Element)) return;

            var searchTrigger = eventTarget.closest(searchTriggerSelector);
            if (searchTrigger) {
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_function',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'top function',
                        'button_name': 'search'
                    }
                });
                return;
            }

            if (eventTarget.closest(quickLinkSelector)) return;

            var suggestion = eventTarget.closest(suggestionSelector);
            if (!suggestion) return;

            var suggestionTitle = suggestion.querySelector(suggestionTitleSelector);
            if (!suggestionTitle) return;

            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'recommend',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'button_name': suggestionTitle.textContent.trim()
                }
            });
        });

        document.addEventListener('submit', function(event) {
            var searchForm = event.target;
            if (!(searchForm instanceof Element)) return;

            var isHeaderSearchForm = searchForm.matches(searchFormSelector);
            var hasLegacySearchSubmit = searchForm.querySelector(legacySearchSubmitSelector);
            if (!isHeaderSearchForm && !hasLegacySearchSubmit) return;

            var searchInput = searchForm.querySelector(searchInputSelector);
            if (!searchInput) return;

            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'search',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'search_term': searchInput.value
                }
            });
        });
    });
    catchErrorEvent('personal', function() {
        var accountButton = document.querySelector('a.icon.flex.jc-center.ai-center');
        if (!accountButton) return;

        accountButton.addEventListener('click', function() {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'click_function',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'top function',
                    'button_name': 'account'
                }
            });
        });

    });
    catchErrorEvent('cart', function() {
        var cartButton = document.querySelector('.header-icons.header-carts.icon');
        if (!cartButton) return;

        cartButton.addEventListener('click', function() {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'click_function',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'top function',
                    'button_name': 'cart'
                }
            });
        });

    });
    catchErrorEvent('click_nav', function() {
        document.querySelectorAll('.footer-menu-container.container .p3').forEach(function(item) {
            item.addEventListener('click', function() {
                var navigationName1 = item.closest('.footer-menu').querySelector('.accordion-title').innerText;
                var navigationName2 = item.innerText;
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_nav',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': navigationName2,
                        'module_name': 'bottom navigation',
                        'first_nav': navigationName1,
                        'second_nav': navigationName2
                    }
                });
            });
        });
    });
    catchErrorEvent('follow_us', function() {
        document.querySelectorAll('.flex.ai-center.bg-black.jc-center.mr-10').forEach(function(item) {
            var FU_pageGroup = getPageGroup(window.location.pathname);
            item.addEventListener('click', function() {
                var buttonName = item.href.split('.')[1];
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'follow_us',
                    'event_parameters': {
                        'page_group': FU_pageGroup,
                        'button_name': buttonName
                    }
                });
            });
        });
    });

    catchErrorEvent('subscribe', function() {
        document.querySelectorAll('.btn1.d-mt-20.mt-15.fsf-submit').forEach(function(item) {
            item.addEventListener('click', function() {
                var method = item.closest('form').querySelector('input[type="email"],[type="tel"]').getAttribute('type');
                var value = item.closest('form').querySelector('input[type="email"],[type="tel"]').value;
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                var phoneRegex = /^\+?[1-9]\d{1,14}$/;
                var buttonName = item.innerText;
                var status;
                setTimeout(function() {
                    var timer = setInterval(function() {
                        if (item.closest('form').querySelector('input[type="email"],[type="tel"]')) {
                            status = 'false';
                        } else {
                            status = 'success';
                        }
                        Shopify.analytics.publish('ga4_common_event', {
                            'event': 'ga4Event',
                            'event_name': 'subscribe',
                            'event_parameters': {
                                'page_group': getPageGroup(window.location.pathname),
                                'button_name': buttonName,
                                'method': method,
                                'status': status
                            }
                        });
                        clearInterval(timer);
                    }, 1000);
                }, 1000);

            });
        });
    });


    // 页面滚动
    // -----scroll start-----

    function handleScrollEvent() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (handleScrollEvent.lastPercentSent >= 90) {
            return false;
        }

        var windowHeight = $narwal.screenHeight;
        var documentHeight = document.documentElement.scrollHeight - windowHeight;

        // 计算滚动百分比
        var scrollPercent = (scrollTop / documentHeight) * 100;
        var percentScrolled = 0;

        // 调试信息
        // console.log("Scroll Top: " + scrollTop);
        // console.log("Window Height: " + windowHeight);
        // console.log("Document Height: " + documentHeight);
        // console.log("Scroll Percent: " + scrollPercent);

        // 确定当前滚动百分比应触发的事件
        if (scrollPercent >= 25 && scrollPercent < 50 && handleScrollEvent.lastPercentSent < 25) {
            percentScrolled = 25;
        } else if (scrollPercent >= 50 && scrollPercent < 75 && handleScrollEvent.lastPercentSent < 50) {
            percentScrolled = 50;
        } else if (scrollPercent >= 75 && scrollPercent < 90 && handleScrollEvent.lastPercentSent < 75) {
            percentScrolled = 75;
        } else if (scrollPercent >= 90 && handleScrollEvent.lastPercentSent < 90) {
            percentScrolled = 90;
        }

        // 检查是否已经推送过相同百分比的事件
        if (percentScrolled > handleScrollEvent.lastPercentSent) {
            console.log('Percent Scrolled: ' + percentScrolled);
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'scroll',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'percent_scrolled': percentScrolled
                }
            });

            // 更新最后推送的百分比
            handleScrollEvent.lastPercentSent = percentScrolled;
        }
    }

    // 初始设置最后推送的百分比为0
    handleScrollEvent.lastPercentSent = 0;

    // 监听页面滚动事件
    window.addEventListener('scroll', handleScrollEvent);

    // // 页面加载时触发一次计算
    window.addEventListener('load', handleScrollEvent);
    //
    // // 保证在页面加载时调用一次滚动处理函数
    handleScrollEvent();

    // 在移动设备上使用 touch 事件来处理滚动
    window.addEventListener('touchmove', handleScrollEvent);
    window.addEventListener('touchend', handleScrollEvent);

    // 监听其他可能影响滚动位置的事件
    window.addEventListener('resize', handleScrollEvent);
    window.addEventListener('orientationchange', handleScrollEvent);

    // ------scroll end-----


    if (pagePath.includes('/account/login')) {

        catchErrorEvent('create_account', function() {
            document.querySelector('[ href="/account/register"]').addEventListener('click', function() {
                var buttonName = document.querySelector('.ai-center.col-6').innerText;
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'create_account',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });


        catchErrorEvent('click_login', function() {
            // ！！！！其他登录点击跳转之后无法继续执行代码，怀疑同步阻塞
            document.querySelectorAll('.d-mt-15.mt-20,.social_login').forEach(function(item) {
                item.addEventListener('click', function(event) {

                    var method = item.getAttribute('aria-label') ? item.getAttribute('aria-label') : 'account';
                    var buttonName = item.getAttribute('aria-label') ? item.getAttribute('aria-label') : 'Sign in';

                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_login',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'method': method,
                            'button_name': buttonName
                        }
                    });

                });
            });

        });
    }

    if (pagePath.includes('/account/register')) {


        // 选择要观察的目标节点
        var targetNode = document.querySelectorAll('.fsf-checkbox [type="checkbox"]')[1];

        // 配置观察选项
        var config = { attributes: true, attributeFilter: ['data-gtm-form-interact-field-id'] };

        // 回调函数，当变动被观察时执行
        var callback = function(mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-gtm-form-interact-field-id') {
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'subscribe',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': 'selected'
                        }
                    });
                }
            }
        };

        // 创建一个观察者实例并传入回调函数
        var observer = new MutationObserver(callback);

        // 开始观察目标节点
        observer.observe(targetNode, config);

    }

    // -----首页-----
    if (pagePath === '/') {

        // view_banner
        catchErrorEvent('view_banner', function() {
            document.querySelectorAll('.image-container').forEach(function(item) {
                var productName = item.querySelector('h3,h1').innerText;
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'view_banner',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'top banner',
                        'product_name': productName
                    }
                });
            });
            document.querySelectorAll('.block-each').forEach(function(item) {
                var productName = item.querySelector('h3,h1').innerText;
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'view_banner',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'recommendation',
                        'product_name': productName
                    }
                });
            });

        });

        // learn more
        catchErrorEvent('click_banner', function() {
            document.querySelectorAll('.btn-b.btn5').forEach(function(item, index) {
                item.addEventListener('click', function() {
                    var productName = item.closest('.block-each').querySelector('h3').innerText;
                    var buttonName = item.innerText;
                    var moduleName = index === 0 ? 'top banner' : 'recommendation';
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_banner',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'recommendation',
                            'product_name': productName,
                            'button_name': buttonName
                        }
                    });
                });
            });


            // buy now
            document.querySelectorAll('.btn-a.btn5').forEach(function(item) {
                item.addEventListener('click', function() {
                    var productName = item.closest('.container').querySelector('h3').innerText;
                    var buttonName = item.innerText;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_banner',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'recommendation',
                            'product_name': productName,
                            'button_name': buttonName
                        }
                    });
                });
            });
        });

        catchErrorEvent('click_srticle', function() {
            document.querySelectorAll('.ba-item.overflow').forEach(function(item) {
                item.addEventListener('click', function() {
                    var blogTitle = item.querySelector('h6').innerText.replace(/[^a-zA-Z0-9\s]/g, '');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_srticle',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'title': blogTitle
                        }
                    });
                });
            });
        });


    }

    // -----support页面-----
    if (pagePath === '/pages/support-center') {

        // test
        catchErrorEvent('click_support', function() {
            document.querySelectorAll('.its-items').forEach(function(item) {
                item.addEventListener('click', async function(event) {
                    event.preventDefault();
                    var buttonName = item.querySelector('.h6').innerText;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'support',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });

                    var ga4Mp = window.__ga4Mp;
                    if (!ga4Mp || !ga4Mp.measurementId || !ga4Mp.apiSecret) {
                        // GA4 MP 未配置，跳过上报但保持跳转
                        window.location.href = event.target.closest('a').getAttribute('href');
                        return;
                    }
                    const endpoint = 'https://www.google-analytics.com/mp/collect?measurement_id=' + ga4Mp.measurementId + '&api_secret=' + ga4Mp.apiSecret;

                    try {
                        // 使用 fetch 发送 GA4 事件
                        const payload = JSON.stringify({
                            client_id: getClientId(), // 从 cookie 中获取 client_id
                            events: [eventData]
                        });
                        await fetch(endpoint, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: payload,
                            keepalive: true // 确保请求在页面卸载时仍然发送
                        });

                        // 确保数据发送成功后进行页面导航
                        window.location.href = event.target.closest('a').getAttribute('href');
                    } catch (error) {
                        console.error('Error sending GA4 event:', error);
                        // 即使发送失败，也进行页面导航
                        window.location.href = event.target.closest('a').getAttribute('href');
                    }
                });
            });
        });
        catchErrorEvent('submit_question', function() {
            document.querySelector('.fsr-submit').addEventListener('click', function() {
                var category = document.querySelector('.text.p2').innerText;
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'submit_question',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'category': category
                    }
                });
            });
        });


    }
    // 产品介绍页
    if (getPageGroup(window.location.pathname) === 'Product introduction page') {

        catchErrorEvent('click_nav', function() {
            document.querySelectorAll('.as-tabs.hd-mr-20').forEach(function(item) {
                item.addEventListener('click', function() {
                    var navigationName1 = item.innerText;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_nav',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'page navigation',
                            'first_nav': navigationName1
                        }
                    });
                });
            });
        });
        catchErrorEvent('buy_now', function() {
            document.querySelector('.btn6.flex-nowrap.btn-show-products').addEventListener('click', function() {
                var buttonName = document.querySelector('.btn6.flex-nowrap.btn-show-products').innerText;
                var productName = document.querySelector('.navbar-brand').innerText;
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'buy_now',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'page navigation',
                        'button_name': buttonName,
                        'product_name': productName

                    }
                });
            });
        });
        catchErrorEvent('buy_now', function() {
            document.querySelectorAll('.ext-link-item a').forEach(function(item) {
                item.addEventListener('click', function() {

                    var buttonName = item.href.split('.')[1];
                    var productName = document.querySelector('.navbar-brand').innerText;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'buy_now',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'buying channel',
                            'button_name': buttonName,
                            'product_name': productName
                        }
                    });
                });
            });
        });
        catchErrorEvent('buy_now', function() {
            document.querySelectorAll('.tcb-button').forEach(function(item) {
                item.addEventListener('click', function() {
                    var productName = document.querySelector('.navbar-brand').innerText;
                    var buttonName = item.innerText;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'buy_now',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'key vision',
                            'button_name': buttonName,
                            'product_name': productName
                        }
                    });
                });
            });
        });
        document.querySelectorAll('.text-center.comparison-button.btn6').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                var productName = item.closest('.comparison-row-value').querySelector('h6').innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_card',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'comparison',
                        'product_name': productName,
                        'button_name': buttonName
                    }
                });
            });
        });
    }


    // 产品分类页
    if (pagePath.includes('/collections') || pagePath.includes('search')) {

        catchErrorEvent('product_category', function() {
            document.querySelectorAll('.nav-link.nav-handler').forEach(function(item) {
                item.addEventListener('click', function() {
                    var buttonName = item.innerText;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'product_category',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            });
        });

        // filter按钮

        document.querySelectorAll('label.radio-container.cursor.square.mb-10 [type="checkbox"],.accordion-wrapper label.radio-container.cursor.square [type="checkbox"]').forEach(function(item) {
            item.addEventListener('change', function() {
                var buttonName = item.parentElement.innerText.replace(/\n/g, ' ');
                if (item.checked) {
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'filter',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'filter_condition': buttonName,
                            'module_name': 'product list'
                        }
                    });
                }
            });
        });


        document.querySelector('.filter-group-display__submit a').addEventListener('click', function() {
            var filter1 = document.querySelector('input[name="filter.v.price.gte"]').value;
            var filter2 = document.querySelector('input[name="filter.v.price.lte"]').value;
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'filter',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'filter_condition': 'Price: From ' + filter1 + ' To ' + filter2,
                    'module_name': 'product list'
                }
            });
        });


        // 根据元素文本变化进行监听
        // 选择要观察的目标节点
        var targetNode = document.querySelector('.sort-by-wrapper .text');

        // 配置观察选项
        var config = { characterData: true, childList: true, subtree: true };

        // 回调函数，当变动被观察时执行
        var callback = function(mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    // 处理目标节点或其子节点的文本内容变化
                    if (mutation.target === targetNode || mutation.target.parentNode === targetNode) {
                        var buttonName = targetNode.innerText.replace(/\n/g, ' ');
                        Shopify.analytics.publish('ga4_common_event', {
                            'event': 'ga4Event',
                            'event_name': 'sort',
                            'event_parameters': {
                                'page_group': getPageGroup(window.location.pathname),
                                'button_name': buttonName,
                                'module_name': 'product list'
                            }
                        });
                    }
                }
            }
        };

        // 创建一个观察者实例并传入回调函数
        var observer = new MutationObserver(callback);

        // 开始观察目标节点
        observer.observe(targetNode, config);


    }

    // 产品详情页
    if (pagePath.includes('/products')) {
        function getProductDetailName() {
            var titleEl = document.querySelector('.info-wrapper h1') ||
                document.querySelector('product-buy-box .product-buy-box__title') ||
                document.querySelector('product-buy-box h1') ||
                document.querySelector('h1');
            return titleEl ? titleEl.innerText.replace(/\n/g, ' ').trim() : '';
        }

        function getCleanText(el) {
            return el ? el.innerText.replace(/\n/g, ' ').trim() : '';
        }

        function publishProductDetailEvent(eventName, params) {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': eventName,
                'event_parameters': Object.assign({
                    'page_group': getPageGroup(window.location.pathname)
                }, params || {})
            });
        }

        function bindProductDetailClick(selector, eventName, getParams) {
            document.querySelectorAll(selector).forEach(function(item) {
                item.addEventListener('click', function(e) {
                    publishProductDetailEvent(eventName, getParams(item, e));
                });
            });
        }

        function findVariantCard(root, variantId) {
            if (!root || !variantId) return null;
            var cards = root.querySelectorAll('[data-variant-id]');
            for (var i = 0; i < cards.length; i++) {
                if (cards[i].getAttribute('data-variant-id') === String(variantId)) {
                    return cards[i];
                }
            }
            return null;
        }

        var productBuyBoxSourceState = {};

        catchErrorEvent('view_img', function() {
            bindProductDetailClick(
                '.swiper-button-next.swiper-button.hide-m.show-d, .product-buy-box-media-gallery__nav--next',
                'view_img',
                function() {
                    return {
                        'module_name': 'product img',
                        'button_name': 'next arrow'
                    };
                }
            );
        });
        catchErrorEvent('view_img', function() {
            bindProductDetailClick(
                '.swiper-button-prev.swiper-button.hide-m.show-d, .product-buy-box-media-gallery__nav--prev',
                'view_img',
                function() {
                    return {
                        'module_name': 'product img',
                        'button_name': 'prev arrow'
                    };
                }
            );
        });
        catchErrorEvent('coupon_interaction', function() {
            bindProductDetailClick(
                '.icon-copy.copy-to-clipboard, [data-promo-copy]',
                'coupon_interaction',
                function(item) {
                    var couponEl = item.closest('.copy-parent')?.querySelector('.label-wrapper') ||
                        item.closest('product-buy-box-promo')?.querySelector('[data-promo-code]');
                    var coupon = getCleanText(couponEl).replace('Copy:', '').trim();
                    return {
                        'button_name': 'copy',
                        'counpon': coupon
                    };
                }
            );
        });
        catchErrorEvent('add_accessories', function() {
            document.querySelectorAll('.product-each-accessories').forEach(function(item) {
                item.addEventListener('click', function() {
                    var buttonName;
                    if (item.classList.contains('active')) {
                        buttonName = 'unselected';
                    } else {
                        buttonName = 'selected';
                    }
                    var productName = getCleanText(item.querySelector('p'));
                    publishProductDetailEvent('add_accessories', {
                        'button_name': buttonName,
                        'product_Name': productName
                    });
                });
            });

            document.addEventListener('product-buy-box:source-change', function(e) {
                var detail = e.detail || {};
                if (detail.source !== 'accessories') return;

                var nextState = {};
                (detail.items || []).forEach(function(item) {
                    nextState[String(item.variantId)] = item;
                });

                Object.keys(nextState).forEach(function(variantId) {
                    if (productBuyBoxSourceState[variantId]) return;
                    var card = findVariantCard(e.target, variantId);
                    var productName = getCleanText(card?.querySelector('.product-buy-box-accessories-card__title')) || variantId;
                    publishProductDetailEvent('add_accessories', {
                        'button_name': 'selected',
                        'product_Name': productName
                    });
                });

                Object.keys(productBuyBoxSourceState).forEach(function(variantId) {
                    if (nextState[variantId]) return;
                    var card = findVariantCard(e.target, variantId);
                    var productName = getCleanText(card?.querySelector('.product-buy-box-accessories-card__title')) || variantId;
                    publishProductDetailEvent('add_accessories', {
                        'button_name': 'unselected',
                        'product_Name': productName
                    });
                });

                productBuyBoxSourceState = nextState;
            });
        });
        catchErrorEvent('add_warranty', function() {
            document.querySelectorAll('.product-each-warranty.global-select-indie').forEach(function(item) {
                item.addEventListener('click', function() {
                    var productName = getCleanText(item.querySelector('.p2'));
                    var buttonName;
                    if (item.classList.contains('active')) {
                        buttonName = 'unselected';
                    } else {
                        buttonName = 'selected';
                    }
                    publishProductDetailEvent('add_warranty', {
                        'button_name': buttonName,
                        'product_Name': productName
                    });
                });
            });

            var productBuyBoxWarrantyState = '';
            document.addEventListener('product-buy-box:source-change', function(e) {
                var detail = e.detail || {};
                if (detail.source !== 'warranty') return;

                var item = detail.items && detail.items[0];
                var nextVariantId = item ? String(item.variantId) : '';

                if (nextVariantId && nextVariantId !== productBuyBoxWarrantyState) {
                    var selectedCard = findVariantCard(e.target, nextVariantId);
                    var selectedName = getCleanText(selectedCard?.querySelector('.product-buy-box-warranty__card-title')) || nextVariantId;
                    publishProductDetailEvent('add_warranty', {
                        'button_name': 'selected',
                        'product_Name': selectedName
                    });
                }

                if (productBuyBoxWarrantyState && productBuyBoxWarrantyState !== nextVariantId) {
                    var unselectedCard = findVariantCard(e.target, productBuyBoxWarrantyState);
                    var unselectedName = getCleanText(unselectedCard?.querySelector('.product-buy-box-warranty__card-title')) || productBuyBoxWarrantyState;
                    publishProductDetailEvent('add_warranty', {
                        'button_name': 'unselected',
                        'product_Name': unselectedName
                    });
                }

                productBuyBoxWarrantyState = nextVariantId;
            });
        });

        catchErrorEvent('buy_now', function() {
            var productName = getProductDetailName();
            document.addEventListener('click', function(e) {
                var button = e.target.closest('.atc-trigger.add-to-cart, .ndev-button__btn[data-cart-buy-now="true"]');
                if (!button || button.dataset.ga4Report) return;

                var buttonName = getCleanText(button);
                if (buttonName !== 'Buy Now' && button.getAttribute('data-cart-buy-now') !== 'true') return;

                publishProductDetailEvent('buy_now', {
                    'product_name': productName,
                    'button_name': buttonName
                });
            });
        });

        catchErrorEvent('click_nav', function() {
            document.querySelectorAll('.nav-each').forEach(function(item) {
                item.addEventListener('click', function() {
                    var buttonName = item.innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'click_nav',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'module_name': 'page navigation',
                            'first_nav': buttonName
                        }
                    });
                });
            });
        });


        document.querySelectorAll('.accordion').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.querySelector('.accordion-title').innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_details',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });

        document.querySelector('.uppercase.show-m-flex');
        catchErrorEvent('download', function() {
            if (document.querySelector('.uppercase.show-m-flex')) {
                document.querySelector('.uppercase.show-m-flex').addEventListener('click', function() {
                    var title = document.querySelector('.uppercase.show-m-flex').closest('.manual-inner').querySelector('.p2').innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'download',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'title': title
                        }
                    });
                });
            }
        });

        var timer_submit_review = setInterval(function() {
            if (document.querySelector('.jdgm-submit-rev.btn_c.button ')) {
                clearInterval(timer_submit_review);
                document.querySelector('.jdgm-submit-rev.btn_c.button ').addEventListener('click', function() {
                    var buttonName = document.querySelector('.jdgm-submit-rev.btn_c.button ').value;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'submit_review',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            }
        }, 1000);

        var timer_submit_question = setInterval(function() {
            document.querySelector('.jdgm-submit-question');
            if (document.querySelector('.jdgm-submit-question')) {
                clearInterval(timer_submit_question);
                document.querySelector('.jdgm-submit-question').addEventListener('click', function() {
                    var buttonName = document.querySelector('.jdgm-submit-question').value;
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'submit_question',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            }
        }, 1000);


        document.addEventListener('click', function(e) {
            var target = e.target instanceof Element ? e.target.closest('.jdgm-subtab__name') : null;
            if (target) {
                var buttonName = target.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'filter',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            }
        });

        var sortTimer = setInterval(function() {
            var sort = document.querySelectorAll('select')[1];
            if (sort) {
                clearInterval(sortTimer);
                sort.addEventListener('change', function() {
                    var buttonName = sort.options[sort.options.selectedIndex].innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'sort',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            }
        }, 1000);
    }


    // 购物车弹窗

    var timer = setInterval(function() {
        document.querySelector('.header-cart .checkout-btn');
        if (document.querySelector('.header-cart .checkout-btn')) {
            clearInterval(timer);
            var checkoutButton = document.querySelector('.header-cart .checkout-btn');
            checkoutButton.addEventListener('click', function() {
                var texts = [];
                var productList = document.querySelectorAll('.details-con h6');
                productList.forEach(element => {
                    texts.push(element.innerText);
                });
                productName = texts.join('_');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'checkout',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'product_name': productName,
                        'button_name': checkoutButton.innerText
                    }
                });
            });
        }
    }, 1000);


    // 联盟页
    if (pagePath.includes('/pages/affiliate')) {

        document.querySelector('.affiliate-cta .btn6').addEventListener('click', function() {
            var buttonName = document.querySelector('.affiliate-cta .btn6').innerText.replace(/\n/g, ' ');
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'join_now',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'page navigation',
                    'first_nav': buttonName
                }
            });
        });

        document.querySelector('.btn1.pt-btn').addEventListener('click', function() {
            var buttonName = document.querySelector('.btn1.pt-btn').innerText.replace(/\n/g, ' ');
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'join_now',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'key vision',
                    'button_name': buttonName
                }
            });
        });
        document.querySelectorAll('.title-icon.accordion-title.jc-between').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'affiliate_detail',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });
        document.querySelector('.d-image-and-button .btn3').addEventListener('click', function() {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'get_started',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'button_name': document.querySelector('.d-image-and-button .btn3').innerText
                }
            });
        });
    }

    // 博文页
    if (pagePath.includes('/pages/blog')) {
        document.querySelectorAll('.nav-link.nav-handler.show-m-inline-block').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'article_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });

        document.querySelectorAll('.article-each-wrapper').forEach(function(item) {
            item.addEventListener('click', function() {
                var blogTitle = item.querySelector('.h6').innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_article',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'title': blogTitle
                    }
                });
            });
        });
    }

    // 评论页
    if (pagePath.includes('/pages/reviews')) {

        document.addEventListener('click', function(e) {
            var target = e.target instanceof Element ? e.target.closest('.jdgm-subtab__name') : null;
            if (target) {
                var buttonName = target.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'filter',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            }
        });

        var timer = setInterval(function() {
            var submitButton = document.querySelector('.jdgm-submit-rev.button');
            if (submitButton) {
                clearInterval(timer);

                // 确保只绑定一次事件监听器
                if (!submitButton.dataset.listenerAdded) {
                    submitButton.addEventListener('click', function() {
                        var buttonName = submitButton.value;
                        Shopify.analytics.publish('ga4_common_event', {
                            'event': 'ga4Event',
                            'event_name': 'review',
                            'event_parameters': {
                                'page_group': getPageGroup(window.location.pathname),
                                'button_name': buttonName
                            }
                        });
                    });

                    // 标记事件监听器已绑定
                    submitButton.dataset.listenerAdded = true;
                }
            }
        }, 1000);


        var timer2 = setInterval(function() {
            var cancelButton = document.querySelector('.jdgm-all-reviews__header .jdgm-write-rev-link.close-form-btn');
            if (cancelButton) {
                clearInterval(timer2);
                cancelButton.addEventListener('click', function() {
                    var buttonName = cancelButton.innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'review',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            }
        }, 1000);


        var timer3 = setInterval(() => {
            var sort = document.querySelectorAll('select')[0];
            if (sort) {
                clearInterval(timer3);
                sort.addEventListener('change', function() {
                    var buttonName = sort.options[sort.options.selectedIndex].innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'sort',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            }
        }, 1000);


    }

    // 售后服务
    if (pagePath === '/pages/after-sales-centre' || pagePath === '/pages/narwal-after-service') {
        document.querySelectorAll('.jc-between.itirl-item').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'after_sales',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'category',
                        'button_name': buttonName
                    }
                });
            });
        });
        document.querySelectorAll('.m-single-btn.dark.middle.flex-center')[1].addEventListener('click', function() {
            var buttonName = document.querySelectorAll('.m-single-btn.dark.middle.flex-center')[1].innerText.replace(/\n/g, ' ');
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'submit_after_sales',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'module_name': 'submit_after_sales',
                    'button_name': buttonName
                }
            });
        });

        document.querySelectorAll('.nav-handler.show-m-inline-block').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });
        document.querySelectorAll('.nav-handler.opacity-5').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'quetion_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });
        document.querySelectorAll('.title-icon.accordion-title').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'quetion_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });

        var timer = setInterval(function() {
            var submitButton = document.querySelectorAll('.m-single-btn.flex-center')[document.querySelectorAll('.m-single-btn.flex-center').length - 1];
            if (submitButton) {
                clearInterval(timer);
                submitButton.addEventListener('click', function() {

                    var buttonName = submitButton.innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'quetion_category',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            }
        }, 1000);
    }

    // 产品帮助页
    if (pagePath.includes('help')) {
        document.querySelectorAll('.account-navigation .nav-link.nav-handler').forEach(function(item) {
            item.addEventListener('click', function() {
                var button = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': button
                    }
                });
            });
        });

        document.querySelectorAll('.left-side .nav-handler').forEach(function(item) {
            item.addEventListener('click', function() {
                var button = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'quetion_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': button
                    }
                });
                getFAQ();
            });
        });

        function getFAQ() {
            document.querySelectorAll('.faq-each-wrapper .accordion-title.accordion-title').forEach(function(item) {
                item.addEventListener('click', function() {
                    var button = item.innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'specific_question',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': button
                        }
                    });
                });
            });
        }

        getFAQ();

    }


    // 视频播放页
    if (pagePath.includes('/pages/tutorial-videos')) {
        document.querySelectorAll('.nav-handler.show-m-inline-block').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
            });
        });
    }

    // FAQ页面
    if (pagePath.includes('/pages/faq-new')) {

        document.querySelectorAll('.nav-wrapper .nav-handler').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'quetion_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'button_name': buttonName
                    }
                });
                getFAQ1();
            });
        });

        function getFAQ1() {
            document.querySelectorAll('.faq-each-wrapper .title-icon.accordion-title').forEach(function(item) {
                item.addEventListener('click', function() {
                    var buttonName = item.innerText.replace(/\n/g, ' ');
                    Shopify.analytics.publish('ga4_common_event', {
                        'event': 'ga4Event',
                        'event_name': 'specific_question',
                        'event_parameters': {
                            'page_group': getPageGroup(window.location.pathname),
                            'button_name': buttonName
                        }
                    });
                });
            });
        }

        getFAQ1();
    }

    if (pagePath === '/pages/user-manual') {
        document.querySelectorAll('.umi-download').forEach(function(item) {
            item.addEventListener('click', function() {
                var title = item.closest('.um-item').querySelector('.umi-title').innerText.replace(/\n/g, ' ');
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'download',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'title': title
                    }
                });
            });
        });
    }
    // ID ME 页面
    if (pagePath === '/pages/idme') {
        document.querySelector('[alt="Verify with ID.me"]').addEventListener('click', function() {
            Shopify.analytics.publish('ga4_common_event', {
                'event': 'ga4Event',
                'event_name': 'verify',
                'event_parameters': {
                    'page_group': getPageGroup(window.location.pathname),
                    'button_name': 'Verify with ID.me'
                }
            });
        });
    }

    // 圣诞页

    // 假期促销页

    // 父亲节促销页
    if (pagePath === '/pages/fathers-day-sale') {
        document.querySelectorAll('.desktop-nav a').forEach(function(item) {

            item.addEventListener('click', function() {
                var navigationName1 = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'click_nav',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'new product',
                        'first_nav': navigationName1
                    }
                });
            });
        });


        document.querySelectorAll('.atc-trigger.btn1').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                var productName = item.closest('.container').querySelector('h5').innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_card',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'top selling',
                        'product_name': productName,
                        'button_name': buttonName
                    }
                });
            });
        });

        document.querySelectorAll('.mccv-product .ai-center.ml-auto.mr-auto.mt-7').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                var productName = item.closest('.mccv-product').querySelector('h6').innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_card',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'comparison',
                        'product_name': productName,
                        'button_name': buttonName
                    }
                });
            });
        });

        document.querySelectorAll('.option').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'comparison',
                        'button_name': buttonName
                    }
                });
            });
        });


        document.querySelectorAll('.nav-handler.opacity-5').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_category',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'accessory',
                        'button_name': buttonName
                    }
                });
            });
        });

        document.querySelectorAll('.product-each-simple .text').forEach(function(item) {
            item.addEventListener('click', function() {
                var buttonName = item.innerText.replace(/\n/g, ' ');
                var productName = item.closest('.product-each-simple').querySelector('.p2').innerText.replace(/\n/g, ' ');
                Shopify.analytics.publish('ga4_common_event', {
                    'event': 'ga4Event',
                    'event_name': 'product_card',
                    'event_parameters': {
                        'page_group': getPageGroup(window.location.pathname),
                        'module_name': 'accessory',
                        'product_name': productName,
                        'button_name': buttonName
                    }
                });
            });
        });
    }

    catchErrorEvent('view_item_list', function() {
        var listId_ga = '';
        var listName_ga = '';
        var completeObserve = new IntersectionObserver(function (entries) {
            var items = [];
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var plid = entry.target.closest('.product-list').getAttribute('data-v4-plid').trim() || 'unknown';
                    var plnm = entry.target.closest('.product-list').getAttribute('data-v4-plnm').trim() || 'unknown';
                    listId_ga = plid;
                    listName_ga = plnm;
                    items.push({
                        item_id: entry.target.getAttribute('data-v4-pid').trim(),
                        item_name: entry.target.getAttribute('data-v4-pnm').trim(),
                        item_list_id: plid,
                        item_list_name: plnm,
                        item_category: entry.target.getAttribute('data-v4-pdtype').trim(),
                        itemVariant: undefined,
                        item_brand: entry.target.getAttribute('data-v4-brand').trim(),
                        price: undefined,
                        quantity: 1,
                        currency: undefined,
                        affiliation: undefined,
                        coupon: undefined,
                        discount: undefined,
                        index: undefined,
                        location_id: undefined,
                        item_category2: undefined,
                        item_category3: undefined,
                        item_category4: undefined,
                        item_category5: undefined,
                    });
                    completeObserve.unobserve(entry.target);
                }
            });
            if (items.length > 0) {
                Shopify.analytics.publish('sce_view_item_list', {
                    event: 'ga4Event',
                    event_name: 'view_item_list',
                    event_parameters: {
                        item_list_name: listName_ga,
                        item_list_id: listId_ga,
                        page_group: getPageGroup(window.location.pathname),
                        items: items,
                    },
                });
            }
        });
    });

    catchErrorEvent('select_item', function() {
        var completeItems = document.querySelectorAll('.main-collection .product-list .product-each-collection');
        completeItems.forEach(function (item) {
            completeObserve.observe(item);
        });
        document
            .querySelectorAll('.main-collection .product-list .product-each-collection')
            .forEach(function (item, index) {
                item.addEventListener('click', function (e) {
                    var plid = item.closest('.product-list').getAttribute('data-v4-plid').trim() || 'unknown';
                    var plnm = item.closest('.product-list').getAttribute('data-v4-plnm').trim() || 'unknown';
                    var productId = item.getAttribute('data-v4-pid').trim();
                    Shopify.analytics.publish('sce_select_item', {
                        event: 'ga4Event',
                        event_name: 'select_item',
                        event_parameters: {
                            item_list_name: listName_ga,
                            item_list_id: listId_ga,
                            page_group: getPageGroup(window.location.pathname),
                            button_name: undefined,
                            items: [
                                {
                                    item_id: productId,
                                    item_name: item.getAttribute('data-v4-pnm').trim(),
                                    index: index,
                                    item_list_id: listId_ga,
                                    item_list_name: listName_ga,
                                    item_category: item.getAttribute('data-v4-pdtype').trim(),
                                    itemVariant: undefined,
                                    item_brand: item.getAttribute('data-v4-brand').trim(),
                                    price: undefined,
                                    quantity: 1,
                                    currency: undefined,
                                    affiliation: undefined,
                                    coupon: undefined,
                                    discount: undefined,
                                    location_id: undefined,
                                    item_category2: undefined,
                                    item_category3: undefined,
                                    item_category4: undefined,
                                    item_category5: undefined,
                                },
                            ],
                        },
                    });
                });
            });
    });
});
